import { LoginFlow } from '@/domains/account-management/partials/login/LoginFlow/LoginFlow';
import { withPublicOnly } from '@/domains/auth/components/routeGuard';
import DefaultLayout from '@/domains/shared/components/layouts/DefaultLayout';
import { NextPageWithLayout } from '@/pages/_app';
import Head from 'next/head';

const Login: NextPageWithLayout = withPublicOnly(() => {
  return (
    <>
      <Head>
        <title>Welcome back</title>
      </Head>
      <LoginFlow />
    </>
  );
});

Login.getLayout = (page: React.ReactElement) => {
  return (
    <DefaultLayout
      logoLink={`${process.env.NEXT_PUBLIC_API_URL}/uk`}
      hideBackButtonOnNativePlatform={true}
    >
      {page}
    </DefaultLayout>
  );
};

export default Login;
